//export const googleMapsApiKey = 'AIzaSyDGbiPmw_9_RfWYV_6bO-7pHXcl8PxBZJg';
export const googleMapsApiKey = 'AIzaSyBC7FXu7_Fikq_RNKthmlihPQ3Gcz5STu8';
